import { render, staticRenderFns } from "./WelcomeSection.vue?vue&type=template&id=ff45779a&"
import script from "./WelcomeSection.vue?vue&type=script&lang=js&"
export * from "./WelcomeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports